import { Skeleton, Td, Tr } from '@chakra-ui/react';

const TableFallback = ({ rows = 1, cols = 1 }) => (
  new Array(rows).fill(0).map((_, r) => (
    <Tr key={r}>
      {new Array(cols).fill(0).map((__, c) => (
        <Td key={c}><Skeleton height="20px" /></Td>
      ))}
    </Tr>
  ))
);
export default TableFallback;
